module.exports = __webpack_public_path__ + "static/media/5.bb38eed7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pps/mozyr/5.jpg
// module id = 242
// module chunks = 0